<template>
  <section class="admin-content " id="contact-search">
    <Navbar/>
    <main class="admin-main">
       <div class="bg-dark m-b-30">
           <div class="container">
               <div class="row p-b-60 p-t-60">

                   <div class="col-md-6 text-center mx-auto text-white p-b-30">
                       <div class="m-b-10">
                           <div class="avatar ">
                               <!-- <div class="avatar-title rounded-circle fe fe-briefcase"></div> -->
                           </div>
                       </div>
                       <h3> </h3>
                       <strong> {{tpas.length}} TPAs</strong>

                   </div>


               </div>
           </div>
       </div>
       <section class="pull-up" v-if="user.type =='shis' || user.id == '2707'">
           <div class="container">

               <div class="row list">
                   <div class="col-lg-12 col-md-8">
                       <div class="card m-b-30">
                           <div class="card-header">

                             <!-- <h3 class="p-t-10 searchBy-name">Add Employee</h3> -->
                           </div>

                           <div class="card-body">
                               <div class="form-group">
                                   <button class="btn btn-primary" @click="show = !show">Add TPA</button>
                               </div>
                           </div>
                       </div>
                   </div>

                   <div class="col-md-12" v-show="show">
                     <div class="card m-b-30">
                       <div class="card-body">

                         <div class="form-row">

                           <div class="form-group floating-label col-md-6">
                               <label>First Name</label>
                               <input type="text" required class="form-control" placeholder="First Name" v-model="register.firstname">
                           </div>
                           <div class="form-group floating-label col-md-6">
                               <label>Last Name</label>
                               <input type="text" required class="form-control" placeholder="Last Name" v-model="register.lastname">
                           </div>

                           <div class="form-group floating-label col-md-6">
                               <label>Organization Name</label>
                               <input type="text" required class="form-control" placeholder="Organization Name" v-model="register.organization_name">
                           </div>

                             <div class="form-group floating-label col-md-6">
                                 <label>Phone Number</label>
                                 <input v-phone type="text" required class="form-control" placeholder="Phone Number" v-model="register.phone_number">
                             </div>
                             <div class="form-group floating-label col-md-4">
                                 <label>Email</label>
                                 <input type="email" required class="form-control" placeholder="Email" v-model="register.email">
                             </div>
                             <div class="form-group floating-label col-md-4">
                                 <label>Password</label>
                                 <input type="password" required class="form-control" placeholder="Password" v-model="register.password">
                             </div>
                             <div class="form-group floating-label col-md-4">
                                 <label>Confirm Password</label>
                                 <input type="password" required class="form-control" placeholder="Password" v-model="register.password_confirmation">
                             </div>

                             <div class="form-group col-md-4">
                                 <label for="tpa-code">HMO Code</label>
                                 <input id="tpa-code" type="text" maxlength="191" class="form-control" placeholder="e.g. HYG-01" v-model.trim="register.tpa_id">
                                 <small class="form-text text-muted">Printed on enrollees' ID cards.</small>
                             </div>
                             <div class="form-group col-md-8">
                                 <label for="tpa-address">Office Address</label>
                                 <input id="tpa-address" type="text" maxlength="1000" class="form-control" placeholder="e.g. 12 Ganaja Road, Lokoja" v-model.trim="register.address">
                             </div>

                       </div>



                         <button @click="registerUser" class="btn btn-primary btn-block btn-lg">Add TPA</button>

                       </div>
                     </div>

                   </div>

                   <div class="col-md-10 m-b-30">
                       <h5> <i class="fe fe-activity"></i>{{tpas.length}} Registered TPAs</h5>
                       <div class="table-responsive">
                           <table class="table align-td-middle table-card">
                               <thead>
                               <tr>
                                   <th>Name of TPA</th>
                                   <th>HMO Code</th>
                                   <!-- <th>E mail</th> -->
                                   <th>Phone Number</th>
                                   <th>Beneficiaries Enrolled</th>
                                   <th>Action</th>
                               </tr>
                               </thead>
                               <tbody>
                               <tr v-for="tpa in tpas" v-bind:key="tpa.id">

                                   <td>
                                     <!-- <router-link :to="{ path: '/provider-' + provider.id }"> -->
                                       {{tpa.organization_name}}
                                   <!-- </router-link> -->

                                   </td>
                                   <td>{{ tpa.tpa_id || '—' }}</td>
                                   <!-- <td>{{tpa.email}}</td> -->
                                   <td>{{tpa.phone_number}}</td>
                                   <td> <strong>{{tpa.enrolledusers_count | numeral('0,0')}}</strong> Enrollees</td>


                                   <td>
                                     <router-link :to="'/tpa/' + tpa.id" class="btn btn-info" :aria-label="'View ' + tpa.organization_name">
                                       <i class="fe fe-eye"></i>
                                     </router-link>
                                     <router-link v-if="canManage" :to="'/edit-tpa/' + tpa.id" class="btn btn-outline-secondary ml-1" :aria-label="'Edit ' + tpa.organization_name">
                                       <i class="fe fe-edit-2"></i>
                                     </router-link>

                                       <!-- <button type="button" @click="editTPA(tpa)" class="btn btn-default"><i class="fe fe-edit"></i></button> -->
                                   </td>
                               </tr>

                               </tbody>
                           </table>

                       </div>
                   </div>



               </div>
           </div>


           <div class="vld-parent">
                <loading :active.sync="isLoading"
                loader="dots"
                :can-cancel="true"
                :is-full-page="fullPage"></loading>
            </div>

       </section>
    </main>
   </section>
</template>

<script>
  import Navbar from '@/views/Navbar.vue'
  // Import component
     import Loading from 'vue-loading-overlay';
     // Import stylesheet
     import 'vue-loading-overlay/dist/vue-loading.css';
     // Init plugin


export default {
  components: {
     Navbar, Loading
  },
  data(){
    return{
      user:null,
      providers:"",
      agencies:"",
      edit:false,
      show:false,
      isLoading: false,
      fullPage: true,
      tpas:"",
      register:{
                email:"",
                phone_number:"",
                state:"",
                agency_name:"",
                ward:"",
                services_offered:"",
                localgovt:"",
                address1:"",
                address:"",
                tpa_id:"",
                firstname:"",
                lastname:"",
                organization_name:"",
                role:0,
                password:"",
                password_confirmation:""
            }
    }
  },
  computed: {
    // Agency admins (the agency account, or staff with user_role 1) edit HMOs.
    canManage() {
      return !!this.user && (this.user.type === "shis" || Number(this.user.user_role) === 1);
    },
  },
  beforeMount(){
    this.user = JSON.parse(localStorage.getItem('user'))
    this.axios.get(`/api/v1/auth/org_agency/90`, { params: { with_counts: 1 } })
                .then(response => {
                    this.tpas = response.data.data
                    console.log(response)
                })
                .catch(error => {
                    console.error(error);
                })
  },
  methods:{

    registerUser(){
      this.user = JSON.parse(localStorage.getItem('user'))
        // the HMO code must be unique in the agency; check before the HMO's sign-in is created
        const code = (this.register.tpa_id || "").toLowerCase();
        if (code && (this.tpas || []).some((t) => String(t.tpa_id || "").trim().toLowerCase() === code)) {
          this.$toasted.error("Another HMO in this agency already has this HMO code.", { position: "top-center", duration: 5000 });
          return;
        }
        this.isLoading = true;
        this.axios.post('/api/v1/auth/registerProvider',{

          email : this.register.email,
          phone_number : this.register.phone_number,
          agency_name : this.register.agency_name,
          firstname : this.register.firstname,
          lastname : this.register.lastname,
          state : '2683',
          localgovt : '767',
          type : 'tpa',
          password : this.register.password,
          password_confirmation : this.register.password_confirmation,
          enrolled_by : 0,
        })
        .then(response=>{
          let tpa_user_id = response.data.data.id

            // add Organization
              this.show = false;
              console.log(response)
              this.axios.post('/api/v1/auth/orgenrollment',{
                user_id : tpa_user_id,
                email : this.register.email,
                phone_number : this.register.phone_number,
                organization_name : this.register.organization_name,
                // KGSHIA (an admin employee's own id is not the agency)
                agency_id : 90,
                tpa_id : this.register.tpa_id || null,
                address : this.register.address || null,
                  })

                  .then(response=>{
                      console.log(response);
                      this.getTPAs()
                      this.clearIt()
                      this.$toasted.info('Organization added Successfully!', {position: 'top-left', duration:5000 })

                  })
                  .catch(error=>{
                      console.log(error.response)
                      const data = (error.response && error.response.data) || {};
                      const first = data.errors && Object.values(data.errors)[0];
                      this.$toasted.error((first && first[0]) || 'The sign-in was created but the organisation was not saved', {position: 'top-center', duration:6000 })
                  })
                  // end of provider

            console.log(response);
            this.isLoading = false;
            this.getTPAs()

        })
        .catch(error=>{
            console.log(error.response)
            this.isLoading = false;
            this.$toasted.error('Sign up not Successful', {position: 'top-left', duration:5000 })

        })
    },
    editTPA(tpa){
      this.show = true;
      this.register.organization_name = tpa.organization_name;
      this.register.phone_number = tpa.phone_number;
      this.register.email = tpa.email;
      this.register.user_id = tpa.user_id;

    },
    getTPAs(){
      this.user = JSON.parse(localStorage.getItem('user'))

      this.axios.get(`/api/v1/auth/org_agency/90`, { params: { with_counts: 1 } })
                  .then(response => {
                      this.tpas = response.data.data
                      console.log(response)
                  })
                  .catch(error => {
                      console.error(error);
                  })
    },

    clearIt(){
      this.register.firstname = "";
      this.register.lastname = "";
      this.register.email = "";
      this.register.phone_number = "";
      this.register.organization_name = "";
      this.register.tpa_id = "";
      this.register.address = "";
    },

  },
  created(){
    this.getTPAs()
  }

}
</script>
